// crm-web/frontend/src/components/analytics/tabRegistry.js
// Central registry de tabs del dashboard de analiticas.
// OCP: agregar un tab = 1 entrada + 1 componente nuevo. Sin tocar AnalyticsView ni TabNav.

import { lazy } from 'react'

// Lazy import reduce el bundle inicial. Se carga el tab cuando el usuario lo abre.
const AgentsTab = lazy(() => import('./tabs/AgentsTab'))
const ClassificationTab = lazy(() => import('./tabs/ClassificationTab'))
const VolumeTab = lazy(() => import('./tabs/VolumeTab'))
const ScheduledHeatmapTab = lazy(() => import('./tabs/ScheduledHeatmapTab'))
const AgendamientosWrapperTab = lazy(() => import('./tabs/AgendamientosWrapperTab'))
const ContactabilityTab = lazy(() => import('./tabs/ContactabilityTab'))

export const TABS = [
  { id: 'agents', label: 'Agentes', component: AgentsTab, adminOnly: false },
  { id: 'classification', label: 'Clasificación', component: ClassificationTab, adminOnly: false },
  { id: 'volume', label: 'Volumen', component: VolumeTab, adminOnly: false },
  { id: 'scheduled', label: 'Agendamientos', component: AgendamientosWrapperTab, adminOnly: false },
  { id: 'contactability', label: 'Contactabilidad', component: ContactabilityTab, adminOnly: false },
]

export const DEFAULT_TAB = 'agents'
